import { inject, Injectable } from '@angular/core';
import { combineQueries, QueryEntity } from '@datorama/akita';
import { map } from 'rxjs/operators';

import { OrganizationQuery } from '@shared/store/organization/organization.query';

import { PaymentMilestoneState, PaymentMilestoneStore } from './payment-milestone.store';

@Injectable({ providedIn: 'root' })
export class PaymentMilestoneQuery extends QueryEntity<PaymentMilestoneState> {
  private organizationQuery = inject(OrganizationQuery);

  protected store: PaymentMilestoneStore;

  constructor() {
    const store = inject(PaymentMilestoneStore);

    super(store);

    this.store = store;
  }

  selectAllMilestones() {
    return combineQueries([this.selectAll(), this.organizationQuery.allVendorsObj$]).pipe(
      map(([mils, organizations]) => {
        return mils.map((mil) => {
          return {
            ...mil,
            organization: mil.organization?.id ? organizations[mil.organization.id] : null,
          };
        });
      })
    );
  }
}
